export default __webpack_public_path__ + "static/media/NCLT-1.8f8a909c.jpg";